import React from "react";
import Footer from "../../components/Footer/Footer.js";
import styles from "./LandingPage.module.css";
import NavBar from "../../components/NavBar/NavBar.jsx";
import Introduction from "../../components/Introduction/Introduction.jsx";
import AboutUs from "../../components/AboutUs/AboutUs.jsx";
import Services from "../../components/Services/Services.jsx";
import ContactForm from "../../components/ContactForm/ContactForm.jsx";
import ContactMe from "../../components/ContactMe/ContactMe.jsx";
import Projects from "../../components/Projects/Projects.jsx";
const LandingPage = () => {
  return (
    <div className={styles.appWrapper}>
      <main className={styles.main}></main>
      <NavBar />
      <Introduction />
      <AboutUs />
      <Services />
      <Projects />
      <div className={`${styles["contact-section"]} contact-section`}>
        <div className={styles["contact-container"]}>
          <ContactMe />
          <ContactForm />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default LandingPage;
